import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ChangePreviewComponent } from './component/change-preview/change-preview.component';
import { ChangePreviewModalComponent } from './feature-modal/change-preview-modal/change-preview-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { ImageModule } from 'primeng/image';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { ImageUploadComponent } from '../core/component/image-upload/image-upload.component';
import { ImageLoadDirective } from '../helper/directive/image-load.directive';
import { FilterPipe } from '../helper/pipe/filter.pipe';
import { ImageDocGridComponent } from './component/image-doc-grid/image-doc-grid.component';
import { GoBackDirective } from './directive/go-back.directive';
import { LazyLoadRowDirective } from './directive/lazy-load-row.directive';
import { NoDoubleClickDirective } from './directive/no-double-click.directive';
import { DateFormatPipe } from './pipe/date-format.pipe';
import { SortPipe } from './pipe/sort.pipe';
import { TitleCaseExtendPipe } from './pipe/title-case-extend.pipe';
import { TranslatePipe } from '../helper/pipe/translate.pipe';

@NgModule({
  declarations: [
    ImageUploadComponent,
    ImageLoadDirective,
    ImageDocGridComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ImageModule,
    TooltipModule
  ],
  exports: [ImageUploadComponent, ImageLoadDirective, ImageDocGridComponent,]
})
export class ImageUploadModule { }



@NgModule({
  declarations: [
    FilterPipe,
    NoDoubleClickDirective,
    DateFormatPipe,
    GoBackDirective,
    LazyLoadRowDirective,
    SortPipe,
    TitleCaseExtendPipe,
    ChangePreviewComponent,
    ChangePreviewModalComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    DropdownModule,
    TableModule,
    CalendarModule,
    ImageUploadModule,
    TranslatePipe,
  ],
  exports: [TitleCaseExtendPipe, DateFormatPipe, NoDoubleClickDirective, FilterPipe, GoBackDirective, LazyLoadRowDirective, SortPipe, ChangePreviewComponent, ChangePreviewModalComponent, TranslatePipe]
})
export class SharedModule { }
